import React, {Component} from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Sidebar from '../../../Components/Sidebar/Index.js'
import { SET_MEETING_BY_ID, ATTEND_MEETING, LEAVE_MEETING } from '../../../Actions/Meetings' 
import { CloseIcon } from '../../../Svg/Index.js'
import ReactHtmlParser from 'react-html-parser';
import ProfileTrigger from '../../../Components/ProfileTrigger/Index.js'


class MeetingDetail extends Component {
 
    state = {
        meeting: null
    }

    componentDidMount() {
        const { user } = this.props;
        if(!user.token) {
            this.props.history.push('/')
        }
        this.props.actions.SET_MEETING_BY_ID(this.props.match.params.id).then(res => {
            this.setState({
                meeting: res
            })
        })
    }

    handleAttendLeave = () => {
        const { meeting } = this.state
        const { user } = this.props
        const isAttendee = !!meeting.users.filter(r => r._id === user._id).length

        if(!isAttendee) {
            this.props.actions.ATTEND_MEETING(meeting._id).then(res => this.setState({meeting: res}))
        } else {
            this.props.actions.LEAVE_MEETING(meeting._id).then(res => this.setState({meeting: res}))
        }
    }

    render() {
        const { user } = this.props
        const { meeting } = this.state
        let html = '';
        let isAttendee = false;
        if(meeting) {
            html = meeting.content;
            isAttendee = !!meeting.users.filter(r => r._id === user._id).length
        }

        return (
            <>
                <div className="o-page-wrap">

                    <Sidebar />
                    <ProfileTrigger />

                    <div className="o-main-container o-main-container--spacing">
                        <div className="c-fixed-back-btn-wrapper">
                            <Link to="/community/meetings" className="c-bare-btn c-fixed-back-btn c-btn c-btn--with-icon">
                                <CloseIcon />
                            </Link>
                        </div>
                        {
                            meeting && (
                                <div className="c-textpage">

                                    {
                                        (!meeting.image && meeting.user_count > 1) && (
                                            <span className="c-event-label">{meeting.user_count} leden komen naar dit event</span>
                                        )
                                    }
                                
                                    {
                                        meeting.image && (
                                            <div className="c-textpage__media" style={{backgroundImage: `url(${meeting.image.meeting_medium})`}}>
                                                {
                                                    meeting.user_count > 1 && (
                                                        <span className="c-event-label">{meeting.user_count} leden komen naar dit event</span>
                                                    )
                                                }
                                            </div>
                                        )
                                    }

                                    <span className="c-textpage__label">{meeting.date_for_humans} { meeting.endTime ? `– ${meeting.endTime}` : '' }<br />{meeting.address}</span>
                                    <h1>{meeting.title}</h1>
                                    <div className="c-textpage__intro">
                                        {meeting.intro}
                                    </div>
                                    <div className="c-textpage__content">
                                        { ReactHtmlParser(html)}
                                    </div>

                                    <div className="c-attend">
                                        <div className="o-spacer"></div>
                                        <div className={`c-attend__inner ${isAttendee ? 'is-active' : ''}`}>
                                            <label className="c-attend__input" htmlFor="attend">
                                                <input type="checkbox" id="attend" name="attend" ref="attend" onChange={this.handleAttendLeave} checked={isAttendee} />
                                                <span>{isAttendee ? 'Je bent erbij. Tot dan!' : 'Ja leuk, ik ben er ook bij'}</span>
                                            </label>
                                        </div>
                                    </div>

                                </div>
                            )
                        }
                        
                    </div>
                </div>
            </>
        )
    }
}
const mapStateToProps = state => {
    return {
        user: state.user.user,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators({ SET_MEETING_BY_ID, ATTEND_MEETING, LEAVE_MEETING }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MeetingDetail)